import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudwatchService } from '../../service';

export type LogGroupsRetentionConfig = typeof LogGroupsRetentionConfig._.Config;

export const LogGroupsRetentionConfig = IntegrationConfig.make({
  service: CloudwatchService,
  name: Integration_Handler_Names_Enum.LogGroupsRetention,
  configSchema: z.object({
    retentionTimeInDays: z.number(),
    logGroupPrefixes: z.array(z.string().min(1)).optional(),
  }),
});
